import React from "react";
import SideBar from "../../components/Sidebar";
import ServicesBox from "./ServicesBox";
import RechargeForm from "./RechargeForm";
import BannerSlider from "./BannerSlider";
import RecentTransactions from "./RecentTransactions";

const MobileRecharge = () => {
  return (
    <div className="container-fluid mt-3">
      <div className="row">
        {/* Sidebar */}
        <SideBar />

        {/* Main Content */}
        <div className="col-md-9 mb-3">
          <div className="card shadow-sm mb-4">
            <div className="card-body">
              {/* Services Box */}
              <div className="mb-3">
                <ServicesBox />
              </div>

              {/* Recharge Section */}

              <RechargeForm type="PREPAID" />
            </div>
          </div>

          <RecentTransactions />
        </div>
      </div>
    </div>
  );
};

export default MobileRecharge;
